/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  ModalBackground,
  ModalContainer,
  ModalContentLeft,
  ModalContentRight,
} from "./Modal2.styles";
import { useSelector } from "react-redux";
import { selectedLocale } from "../../store/slices/common/slice";

const Modal2 = ({
  open,
  children,
  width,
  responsive,
  height,
  right,
  hideScrollToTop,
  padding,
  unset,
  bg,
  borderRadius,
  border,
  smallPadding,
  className,
  paddingOuter,
  onClose,
  bgColor,
  paddingTop,
  blur,
  left,
  style,
}) => {
  const [isVisible, setIsVisible] = useState(open);
  const modalContentRef = useRef(null);

  const handleBackgroundClick = (e) => {
    if (!modalContentRef.current.contains(e.target)) {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape" && onClose) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  useEffect(() => {
    let timer;
    if (open) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 250);
    }

    return () => clearTimeout(timer);
  }, [open]);

  useEffect(() => {
    const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);

    if (isVisible) {
      document.documentElement.style.overflow = "hidden";
      document.documentElement.style.paddingRight = isMobileDevice
        ? "0px"
        : "8px";
      hideScrollToTop && window.scrollTo(0, 0);
    } else {
      document.documentElement.style.overflow = "auto";
      document.documentElement.style.paddingRight = "0px";
    }
  }, [isVisible, hideScrollToTop]);

  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";

  return isVisible ? (
    <ModalBackground
      $open={open}
      onClick={handleBackgroundClick}
      style={{
        backgroundColor: bgColor,
        backdropFilter: `blur(${blur})`,
        zIndex: style?.zIndex || 1000000,
      }}
    >
      <ModalContainer
        $right={right}
        $left={left}
        style={{ padding: paddingOuter }}
      >
        {right ? (
          <ModalContentRight
            $responsive={responsive}
            $smallPadding={smallPadding}
            style={{
              background: bg,
              border: border,
              borderRadius: borderRadius,
              paddingTop: paddingTop,
            }}
            $open={open}
            $left={left}
            $right={right}
            className={className}
            width={width}
            height={height}
            padding={padding}
            $unset={unset}
            ref={modalContentRef}
          >
            {children}
          </ModalContentRight>
        ) : (
          <ModalContentLeft
            $responsive={responsive}
            $smallPadding={smallPadding}
            style={{
              background: bg,
              border: border,
              borderRadius: borderRadius,
              paddingTop: paddingTop,
            }}
            $open={open}
            $left={left}
            $right={right}
            className={className}
            $ar={ar}
            width={width}
            height={height}
            padding={padding}
            $unset={unset}
            ref={modalContentRef}
          >
            {children}
          </ModalContentLeft>
        )}
      </ModalContainer>
    </ModalBackground>
  ) : (
    <></>
  );
};

export default Modal2;
